import { GetBestFill, fill_len } from "@pdfking/filling"
import type { Distance, Rectangle } from "@pdfking/math"
import { InfinityQ, Trunc } from "@pdfking/math"
import type { Percentage } from "@pdfking/structs"

import type { ComponentSchema } from "#internal"

const WASTE_WARNING_THRESHOLD = 0.05

/**
 * Cut waste: the fraction of a material sheet lost when it's cut into press
 * sheets (`machine_size`). Mirrors Python `_get_imposition_data`
 * (`concrete.py:353-375`): `best_fill(material_size, strategy)` tiles the press
 * sheet onto the material, then `waste = 1 - sheet_area * count / material_area`.
 * Returns `undefined` (no warning) for the unbounded "no" material, when there's
 * no job, or when waste is under 5%.
 */
export const ComputeMaterialCutWastePercent = (
  component: ComponentSchema
): Percentage | undefined => {
  const material = component.material
  if (InfinityQ(material.width)) return undefined

  const sheet = component.job_array[0]?.machine_size
  if (!sheet) return undefined

  const material_sheet = material as Rectangle<Distance>
  const count = fill_len(GetBestFill(material_sheet, sheet))
  if (!count) return undefined

  const waste = 1 - (sheet.width * sheet.height * count) / (material.width * material.height)

  if (waste < WASTE_WARNING_THRESHOLD) return undefined
  return Trunc(waste * 100) as Percentage
}
